module.exports = __webpack_public_path__ + "static/media/Step3.58419127.svg";